import { render, staticRenderFns } from "./SupportEmailCreate.vue?vue&type=template&id=4e8c1ab4"
import script from "./SupportEmailCreate.vue?vue&type=script&lang=js"
export * from "./SupportEmailCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports